import React from "react";

import { commonMenuItems as menuItems } from "../commonMenu.config";
import MenuItems from "./MenuItems";

/** mui */
import { makeStyles } from "@material-ui/core/styles";
/** - icons */

/** Redux */

const useStyles = makeStyles((theme) => ({
    menus: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        listStyle: "none",
        margin: theme.spacing(0, 0, 0, 0),
    },

    menuChildren: {
        position: "relative",
        fontSize: "0.875rem",
        color: "rgba(0,0,0,0.87)",
        "& button": {
            padding: "0.7rem 1rem",
            display: "flex",
            alignItems: "center",
            color: "inherit",
            fontSize: "inherit",
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
            width: "100%",
            // padding: 0,
            "& span": {
                marginLeft: theme.spacing(-2),
            },
        },
    },
    shareIcon: {
        // color: "rgba(0, 0, 0, 0.87)",
        // color: "#fff",
        // fontSize: "1.1rem",
    },
    shareBtnDark: {
        "&, &:hover": {
            // backgroundColor:'#202020',
            // backgroundColor:'rgba(255, 255, 255, 0.5)',
            backgroundColor: "rgba(0, 0, 0, 0.87)",
            // boxShadow: theme.shadows[1],
            // backgroundColor: "rgba(0, 0, 0, 0.87)",
            // borderRadius:4,
            width: 32,
            height: 32,
            border: "2px solid rgba(255, 255, 255, 1)",
            // border: "2px solid rgba(0, 0, 0, 1)",
            margin: theme.spacing(0, 1, 0, 1),
        },
        "& svg": {
            color: "#fff",
            fontSize: "1.1rem",
        },
    },

    shareBtnLight: {
        "&, &:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            width: 32,
            height: 32,
            // border: "2px solid rgba(255, 255, 255, 1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            margin: theme.spacing(0, 1, 0, 1.5),
        },
        "& svg": {
            color: "rgba(0, 0, 0, 0.75)",
            fontSize: "1.1rem",
        },
    },
}));

const DropdownMenu = (props) => {
    const { isMobile } = props;
    const classes = useStyles();

    return (
        <nav id="global-main-menu">
            <ul className={classes.menus}>
                {menuItems
                    .filter((menu) => (isMobile ? true : !menu.mobileOnly))
                    .map((menu, index) => {
                        const depthLevel = 0;
                        return <MenuItems items={menu} key={index} depthLevel={depthLevel} isMobile={isMobile} />;
                    })}
            </ul>
        </nav>
    );
};

export default DropdownMenu;
